// extracted by css-extract-rspack-plugin
export default {"container":"AgentDetails-module__container__w2nnY","content":"AgentDetails-module__content__BH0YF","hideOnDesktop":"AgentDetails-module__hideOnDesktop__qwFgd"};